import React, { useState, useRef, useEffect } from 'react';
import '../styles/Dashboard.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import img3 from '../assets/image 3.png';
import img2 from '../assets/image 2.png';
import grp22 from '../assets/Group 22.png';
import grp23 from '../assets/Group 23.png';
import img5 from '../assets/image 5.png';
import Sidebar from '../components/Sidebar';

import { FaBell, FaUserCircle } from 'react-icons/fa';

const Dashboard = () => {
    const [activeItem, setActiveItem] = useState('dashboard');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [dashboardData, setDashboardData] = useState({
        totalBoard: 0,
        totalGrade: 0,
        totalSubjects: 0,
        totalPapers: 0,
        totalQuestions: 0,
    });

    const [user, setUser] = useState({
        id: null,
        name: '',
        email: '',
        password: '',
    });

    // Fetch dashboard & user data
    useEffect(() => {
        const fetchDashboardData = async () => {
            try {
                const token = localStorage.getItem("token");
                const res = await axios.get("https://digital.tifleducation.com/admin/public/api/getDashboard", {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (res.data) {
                    setDashboardData({
                        totalBoard: res.data.totalBoards || 0,
                        totalGrade: res.data.totalGrades || 0,
                        totalSubjects: res.data.totalSubjects || 0,
                        totalPapers: res.data.totalPapers || 0,
                        totalQuestions: res.data.totalQuestions || 0,
                    });
                    if (res.data.user) {
                        setUser({
                            id: res.data.user.id,
                            name: res.data.user.name || '',
                            email: res.data.user.email || '',
                            password: '', // empty for editing
                        });
                    }
                }
            } catch (error) {
                console.error("Error fetching dashboard data:", error.response?.data || error);
            }
        };

        fetchDashboardData();
    }, []);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, []);

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    // Handle save changes
    const handleSaveProfile = async () => {
        try {
            const token = localStorage.getItem("token");
            await axios.post(
                "https://digital.tifleducation.com/admin/public/api/update-profile",
                {
                    name: user.name,
                    password: user.password,
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            toast.success("Profile updated successfully!");

            setIsModalOpen(false);
            setUser({ ...user, password: '' }); // reset password field
        } catch (error) {
            console.error("Error updating profile:", error.response?.data || error);

            toast.error("Failed to update profile");

        }
    };

    return (
        <div className="dashboard-container">
            <Sidebar
                isSidebarOpen={isSidebarOpen}
                setIsSidebarOpen={setIsSidebarOpen}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
            />

            <main className="main-content">
                <div className="dashboard-header">
                    <div className="welcome-text">Welcome {user.name || "!!"} !!</div>

                    <div className="header-icons" ref={dropdownRef}>
                        <FaBell className="icon" />

                        <div className="user-dropdown-wrapper">
                            <FaUserCircle className="icon" onClick={toggleDropdown} />
                            {showDropdown && (
                                <div className="user-dropdown">
                                    <div className='edituser' onClick={() => setIsModalOpen(true)}>
                                        <FaUserCircle className="ditusericon" />
                                        <span>Edit Profile</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Dashboard Cards */}
                <div className="dashboard-cards">
                    <div className="card"><h4>Total Board</h4><p>{dashboardData.totalBoard}</p></div>
                    <div className="card"><h4>Total Grade</h4><p>{dashboardData.totalGrade}</p></div>
                    <div className="card"><h4>Total Subjects</h4><p>{dashboardData.totalSubjects}</p></div>
                    <div className="card"><h4>Total Papers</h4><p>{dashboardData.totalPapers}</p></div>
                    <div className="card"><h4>Total Questions</h4><p>{dashboardData.totalQuestions}</p></div>
                </div>

                {/* Quick Links */}
                <div className="quick-links">
                    <h3 className="quick-title">Quick Links</h3>
                    <div className="quick-grid">
                        <a href="/papers">
                        <div className="quick-box"><img src={img3} alt="Generate Papers" /><p>Generate Papers</p></div>
                        </a>

                        <a href="/questions/createque">
                        <div className="quick-box"><img src={img2} alt="Create Questions" /><p>Create Questions</p></div></a>
                        <a href="/papers/prebuild">
                        <div className="quick-box"><img src={grp22} alt="Ready-Made Papers" /><p>Ready-Made Papers</p></div>
                        </a>
                        <a href="/papers/mypapers">
                        <div className="quick-box"><img src={grp23} alt="Saved Papers" /><p>Saved Papers</p></div>
                        </a>
                        <a href="/questions/myquestions">
                        <div className="quick-box"><img src={img5} alt="Answers Key" /><p>Edit Questions</p></div>
                        </a>
                    </div>
                </div>
            </main>

            {/* Profile Edit Modal */}
            {isModalOpen && (
                <div style={modalStyles.overlay}>
                    <div style={modalStyles.modal}>
                        <button style={modalStyles.closeBtn} onClick={() => setIsModalOpen(false)}>&times;</button>
                        <div style={modalStyles.userIcon}><FaUserCircle /></div>

                        <div style={modalStyles.formGroup}>
                            <label>Username</label>
                            <input
                                type="text"
                                value={user.name}
                                onChange={(e) => setUser({ ...user, name: e.target.value })}
                                style={modalStyles.input}
                            />
                        </div>

                        <div style={modalStyles.formGroup}>
                            <label>Email</label>
                            <input type="email" value={user.email} disabled style={{ ...modalStyles.input, background: '#f0f0f0', color: '#888' }} />
                        </div>

                        <div style={modalStyles.formGroup}>
                            <label>Password</label>
                            <input
                                type="password"
                                value={user.password}
                                onChange={(e) => setUser({ ...user, password: e.target.value })}
                                style={modalStyles.input}
                            />
                        </div>

                        <div style={{ textAlign: 'right' }}>
                            <button style={modalStyles.saveBtn} onClick={handleSaveProfile}>Save Changes</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

// Modal inline styles
const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0, left: 0, width: "100%", height: "100%",
        background: "rgba(0,0,0,0.6)",
        display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000
    },
    modal: {
        background: "#fff", padding: "2rem", borderRadius: "12px",
        width: "90%", maxWidth: "400px", position: "relative",
        boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
    },
    closeBtn: {
        position: "absolute", top: "10px", right: "15px",
        background: "none", border: "none", fontSize: "1.5rem", cursor: "pointer"
    },
    userIcon: {
        textAlign: "center", fontSize: "4rem", color: "#129255", marginBottom: "1rem"
    },
    formGroup: { marginBottom: "1rem" },
    input: { width: "100%", padding: "0.5rem 0.8rem", borderRadius: "6px", border: "1px solid #ccc", outline: "none" },
    saveBtn: { background: "#129255", color: "#fff", border: "none", padding: "0.6rem 1.2rem", borderRadius: "6px", cursor: "pointer", fontWeight: "bold" }
};

export default Dashboard;
